import React from 'react';

// Datenschutzerklärung tailored to what this site actually does:
// Netlify hosting (US transfer), server logs, the Netlify contact form,
// self-hosted fonts, no cookies / no tracking. Rendered inside the black
// overlay with the .overlay-legal styling.
export default () => (
  <div className="column">
    <h1>Datenschutzerklärung</h1>

    <p>
      Mit dieser Datenschutzerklärung informieren wir Sie über Art, Umfang und
      Zweck der Verarbeitung personenbezogener Daten auf dieser Website nach der
      Datenschutz-Grundverordnung (DSGVO) und dem Bundesdatenschutzgesetz (BDSG).
    </p>

    <h2>Verantwortlicher</h2>
    <p>
      Camill von Egloffstein<br/>
      Sommerstraße 24<br/>
      81543 München<br/>
      E-Mail: <a href="mailto:camillvegloffstein@icloud.com">camillvegloffstein@icloud.com</a>
    </p>

    <h2>Cookies und Tracking</h2>
    <p>
      Diese Website verwendet keine Cookies und setzt keine Analyse-, Tracking-
      oder Werbedienste ein. Es findet kein Profiling statt. Lediglich ein
      technisch notwendiger Eintrag im lokalen Speicher Ihres Browsers
      (localStorage) merkt sich, dass Sie den Datenschutzhinweis geschlossen
      haben. Dieser Eintrag enthält keine personenbezogenen Daten und wird nicht
      an uns oder Dritte übertragen.
    </p>

    <h2>Hosting</h2>
    <p>
      Diese Website wird bei der Netlify, Inc. (USA) gehostet. Beim Aufruf der
      Website verarbeitet Netlify als Auftragsverarbeiter technische Daten, die
      Ihr Browser übermittelt (siehe „Server-Log-Dateien“). Mit Netlify besteht
      ein Auftragsverarbeitungsvertrag. Da eine Übermittlung in die USA nicht
      ausgeschlossen werden kann, erfolgt diese auf Grundlage der
      Standardvertragsklauseln der EU-Kommission bzw. – soweit vorhanden – einer
      Zertifizierung nach dem EU-U.S. Data Privacy Framework. Rechtsgrundlage ist
      unser berechtigtes Interesse an einem sicheren und effizienten Betrieb der
      Website (Art. 6 Abs. 1 lit. f DSGVO). Weitere Informationen:{' '}
      <a href="https://www.netlify.com/privacy/" target="_blank" rel="noopener noreferrer">
        netlify.com/privacy
      </a>.
    </p>

    <h2>Server-Log-Dateien</h2>
    <p>
      Beim Besuch der Website werden automatisch Informationen erfasst, die Ihr
      Browser übermittelt. Dies sind insbesondere:
    </p>
    <ul>
      <li>aufgerufene Seite (URL)</li>
      <li>Browsertyp und -version</li>
      <li>verwendetes Betriebssystem</li>
      <li>zuvor besuchte Seite (Referrer-URL)</li>
      <li>IP-Adresse</li>
      <li>Datum und Uhrzeit des Zugriffs</li>
    </ul>
    <p>
      Diese Daten dienen der technischen Bereitstellung, der Sicherheit und der
      Stabilität der Website und werden nicht mit anderen Datenquellen
      zusammengeführt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Die
      Speicherung erfolgt nur für die zur Erreichung dieser Zwecke erforderliche
      Dauer.
    </p>

    <h2>Kontaktaufnahme</h2>
    <p>
      Wenn Sie uns über das Kontaktformular oder per E-Mail kontaktieren, werden
      die von Ihnen angegebenen Daten (Name, E-Mail-Adresse, Telefonnummer sowie
      der Inhalt Ihrer Nachricht) zum Zweck der Bearbeitung Ihrer Anfrage
      verarbeitet. Die Übermittlung des Kontaktformulars erfolgt über den Dienst
      „Netlify Forms“ (Netlify, Inc., USA) als Auftragsverarbeiter; hinsichtlich
      der Datenübermittlung in die USA gelten die Ausführungen unter „Hosting“.
    </p>
    <p>
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage auf den
      Abschluss oder die Durchführung eines Vertrags gerichtet ist, andernfalls
      unser berechtigtes Interesse an der Beantwortung Ihrer Anfrage
      (Art. 6 Abs. 1 lit. f DSGVO). Die Daten werden gelöscht, sobald sie zur
      Erreichung des Zwecks nicht mehr erforderlich sind und keine gesetzlichen
      Aufbewahrungspflichten entgegenstehen.
    </p>

    <h2>Schriftarten</h2>
    <p>
      Die verwendeten Schriftarten werden lokal von unserem Server geladen. Es
      besteht keine Verbindung zu Servern Dritter (z. B. Google Fonts); hierfür
      werden keine Daten an Dritte übertragen.
    </p>

    <h2>SSL-/TLS-Verschlüsselung</h2>
    <p>
      Diese Website nutzt aus Sicherheitsgründen eine TLS-Verschlüsselung. Eine
      verschlüsselte Verbindung erkennen Sie an „https://“ in der Adresszeile
      Ihres Browsers.
    </p>

    <h2>Ihre Rechte</h2>
    <p>Ihnen stehen nach der DSGVO folgende Rechte zu:</p>
    <ul>
      <li>Auskunft über die verarbeiteten Daten (Art. 15 DSGVO)</li>
      <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
      <li>Löschung (Art. 17 DSGVO)</li>
      <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
      <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
      <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
    </ul>
    <p>
      Soweit die Verarbeitung auf einer Einwilligung beruht, können Sie diese
      jederzeit mit Wirkung für die Zukunft widerrufen. Zur Ausübung Ihrer Rechte
      genügt eine formlose Nachricht an die oben genannten Kontaktdaten.
    </p>

    <h2>Beschwerderecht</h2>
    <p>
      Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu
      beschweren. Die für uns zuständige Behörde ist:
    </p>
    <p>
      Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)<br/>
      Promenade 18<br/>
      91522 Ansbach
    </p>

    <p>Stand: Juni 2026</p>
  </div>
);
